import PageStyle from '@/styles/components/setupmodel/_index.module.scss';
import ButtonStyle from '@/styles/components/button/_index.module.scss';
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import { FormModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import Button from '@/components/button';
import Autosuggest from 'react-autosuggest';
import {cursorNone, useState, AutocompleteError, getTechTestData, InputError, Formik, Form, FormikControl, TRANSLATION, Yup, useRouter, useEffect, useTranslation, Field, TechTestAction, MANAGE_ASSESSMENT, URL_FORMAT} from '@/imports-files/pages/clients/jobs/automations';
import ClientDashboard from 'src/layouts/ClientDashboard';
import {sendCustomTechTest} from '@/imports-files/pages/clients/candidates/kanban';
import Error from 'public/icons/error_exclamation.svg';

function CustomTechTestModal({setBtnPopup, editable, router, from, job_id, params, setSelectedCards, setActionBar, activeTab, setJobData, setInitialData, setFlagForRerender})
{
  const [tests, setTests] = useState([])
  const [uploadFileText, setUploadFileText] = useState('Upload a file')
  const techTestAction = new TechTestAction(setTests);
  const job_test_detail = {
                            "test_id": '',
                            "test_type": 'TestLibrary',
                            "member_initials": [],
                            "member_emails": [],
                            "days_to_expire": '',
                            "assessment": {
                              name: '',
                              file_type: 'link',
                              link: '',
                              file: '',
                              filename: '',
                              filesize: '',
                            }
                          } 
  
  const [techTest, setTechTest]             =   useState('');
  const { t, i18n }                         =   useTranslation();
  const initialValues                       =   job_test_detail
  const [validationData, setValidationData] = useState({type: 'TestLibrary', test_id: ''});
           

  function validations(validationData){
    const schema =
      Yup.object({
        test_id: Yup.string().required("Invalid test"),
        days_to_expire: Yup.string().required(TRANSLATION('common:errors:required')),
        test_type: Yup.string(),
        assessment: Yup.object()
        .shape({
          ...((validationData.type == 'Assessment') && (validationData.test_id.toString() == 'upload_new_test') ? {
            name: Yup.string().required(TRANSLATION('common:errors:required')),
            file_type: Yup.string().required(TRANSLATION('common:errors:required')),
            link: Yup.string().when("file_type", {
              is: (file_type) => file_type == 'link',
              then: Yup.string().required(TRANSLATION('common:errors:required')).matches(URL_FORMAT, 'Assessment link is invalid.'),
              otherwise: Yup.string().notRequired()
            }),
            filename: Yup.string().when("file_type", {
              is: (file_type) => file_type == 'file',
              then: Yup.string().required(TRANSLATION('common:errors:required')),
              otherwise: Yup.string().notRequired()
            }),
            filesize: Yup.string().when("file_type", {
              is: (file_type) => file_type == 'file',
              then: Yup.string().test("is-greater", "Max. allowed file size 10 MB.", function(value) {
                let currentFileSize = parseInt(value) || 0
                return currentFileSize < MANAGE_ASSESSMENT.file_size
              }),
              otherwise: Yup.string().notRequired()
            }),
          } : {
          }),
        }),
      })
    return schema
  }
  
  function getSuggestionValue(suggestion) {
    return suggestion.code;
  }

  function renderSuggestion(suggestion) {
    return (
      <span>{suggestion.name}</span>
    );
  }

  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  async function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.value.trim());
    if (escapedValue === '') {
      return [];
    }
    let techTests = await getTechTestData(escapedValue)
    return techTests
  }
  
  async function onSuggestionsFetchRequested(value){
    let techTests = await getSuggestions(value)
    setTests(techTests)
  };

  const onSuggestionsClearRequested = () => {
    setTests([])
  };

  const renderInputComponent = inputProps => (
      <input className = {PageStyle.Form__Input} autoComplete={"password"}
      {...inputProps} />
  );

  function shouldRenderSuggestions(value){
    return value.trim().length >= 3
  }

  return (
  <>
  <div className={`${FormModalStyle.ModalOverlay}`}>
    <div className={`${FormModalStyle.Modal} AutomationPopup AddInterview`}>
      <div className={`${FormModalStyle.Modal__Container}`}>
      <div className={`${FormModalStyle.Modal__Container__CloseSection}`}
            onClick={() => setBtnPopup(false)}>
            <Close />
            CLOSE
          </div>
      

      <div className={FormModalStyle.Modal__Container__ContentSection}>
        <h1 className={`${FormModalStyle.Modal__Container__ContentSection__Heading}`}>{t('page:clients:tech-test-modal:texts:title')}</h1>
        <h4 className={
                FormModalStyle.Modal__Container__ContentSection__Description
              }>{t('page:clients:tech-test-modal:texts:subheading')}</h4>

        <Formik
          initialValues={initialValues}
          validationSchema={validations(validationData)}
          onSubmit={
            async (values) => {
              await sendCustomTechTest({
                job_id                :   job_id,
                values                :   values,
                params                :   params,
                router                :   router,
                setBtnPopup           :   setBtnPopup,
                setSelectedCards      :   setSelectedCards,
                setActionBar          :   setActionBar,
                activeTab             :   activeTab,
                setJobData            :   setJobData,
                from                  :   from,
                setInitialData        :   setInitialData,
                setFlagForRerender    :   setFlagForRerender
              })
          }}>
          {(formik) => (
            <Form>


            <div className={`WrapperRadioDpBlock`}>

              <div className={`WrapperRadioGrid mt20`}>
                <label className={`Dpflex WrapperRadioContainer mb0 ${PageStyle.SetupPopup__Content__Radiobtn}`}>
                  <Field type="radio" name="test_type" id="test_type_1" value={'TestLibrary'} checked={formik.values.test_type == 'TestLibrary'} onChange={(event)=> techTestAction.onOptionChange(formik, event, setTechTest, validationData, setValidationData, 'custom')} />  
                  <span className="WrapperRadiocheckmark ml0"></span> 
                  <span className={`ml5 WrapperRadioSpan`}> IKM tech tests</span>
                </label>

                <label className={`Dpflex WrapperRadioContainer mb0 ${PageStyle.SetupPopup__Content__Radiobtn}`}>
                  <Field type="radio" name="test_type" id="test_type_2" value={'Assessment'} checked={formik.values.test_type == 'Assessment'} onChange={(event)=> techTestAction.onOptionChange(formik, event, setTechTest, validationData, setValidationData, 'custom')} />  
                  <span className="WrapperRadiocheckmark mt0 ml0"></span>
                  <span className={`ml5 WrapperRadioSpan`}> Your tech test</span>
                </label>
              </div>

              </div>
              <div className={`${PageStyle.NeedHelp}`}>
                {validationData.type == 'TestLibrary' && <p>Need help deciding which assessment to send? <a href="https://ikmnet.com/products/skills-assessments/" target="_blank">Click here</a> for help guide</p>}
                      </div> 
              <div className={`${PageStyle.SetupPopup__ContentGridTech} cpblock`}>
                <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt25}`}>
                <label>{t('page:clients:tech-test-modal:texts:select_test')} *</label> 
                {/* <Autosuggest 
                  suggestions={tests}
                  onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                  onSuggestionsClearRequested={onSuggestionsClearRequested}
                  getSuggestionValue={getSuggestionValue}
                  renderSuggestion={renderSuggestion}
                  renderInputComponent={renderInputComponent}
                  shouldRenderSuggestions={shouldRenderSuggestions}
                  onSuggestionSelected={(event, {suggestion}) => {
                    setTechTest(suggestion.name);
                    formik.setFieldValue("test_id",suggestion.id)
                  }}
                  inputProps={{
                    className: `${PageStyle.Form__Input} input350`,
                    placeholder: `e.g ${t('common:texts:example_select_test')}`,
                    value: techTest,
                    disabled: !editable,
                    onChange: (value, {newValue, method}) => {
                      setTechTest(newValue)
                      formik.setFieldValue("test_id",'')
                    },
                    name: "test_id"
                  }
                  }
                >
                </Autosuggest> */}

                <Autosuggest 
                    suggestions={tests}
                    onSuggestionsFetchRequested={(value) => techTestAction.onSuggestionsFetchRequested(value, techTestAction, formik.values.test_type, true)}
                    onSuggestionsClearRequested={() => setTests([])}
                    getSuggestionValue={techTestAction.getSuggestionValue}
                    renderSuggestion={techTestAction.renderSuggestion}
                    renderInputComponent={techTestAction.renderInputComponent}
                    shouldRenderSuggestions={() => formik.values.test_type == 'Assessment' ? true : techTestAction.shouldRenderSuggestions}
                    onSuggestionSelected={(event, {suggestion}) => {
                      setTechTest(suggestion.name);
                      formik.setFieldValue("test_id", suggestion.id)
                      techTestAction.setCustomTestOptions(formik, suggestion.id.toString(), validationData, setValidationData)
                    }}
                    inputProps={{
                      className: `${PageStyle.Form__Input} input350`,
                      placeholder: `e.g ${t('common:texts:example_select_test')}`,
                      value: techTest,
                      disabled: !editable,
                      onChange: (value, {newValue, method}) => {
                        setTechTest(newValue)
                        formik.setFieldValue("test_id",'')
                      },
                      name: "test_id"
                    }
                    }
                  >
                  </Autosuggest>



                <AutocompleteError 
                  name="test_id"
                  errorClass={PageStyle.Form__Error}
                  formik = {formik}
                  style={InputError(formik, "test_id")}
                  />
                
              </div>

              <div className={`${PageStyle.SetupPopup__ContentBlock} ${PageStyle.mt25}`}>
              <label className={`Dpflex`}>
              {t('page:clients:tech-test-modal:texts:expires_in')} * <span>({t('page:clients:tech-test-modal:texts:days')})</span>
            </label>
                <FormikControl 
                  className={`${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`}
                  control="input"
                  type="text"
                  placeholder="e g. 5"
                  disabled = {!editable}
                  formik = {formik}
                  name="days_to_expire"
                  maxLength = {2}
                  onChange= { (evt) => {
                    let new_value = isNaN(evt.target.value) ? 1 : (parseInt(evt.target.value) == 0 ? '' : evt.target.value)
                    formik.setFieldValue("days_to_expire", new_value)
                    return new_value
                  }}
                  style = {InputError(formik, 'days_to_expire')}
                >
                </FormikControl>
                
              
                </div>

                {formik.values.test_id.toString() == 'upload_new_test' && <div className={`${PageStyle.SetupPopup__Assesmentsection} asessment-form-section`}>
                  <div className={`${PageStyle.SetupPopup__ContentBlock} cpblock`}>
                    <div className={`${PageStyle.SetupPopup__ContentBlock}`}>
                      <label>{t('page:clients:tech-test-modal:texts:assesment_heding')}</label> 
                      <FormikControl
                        className     =   {PageStyle.Form__Input}
                        control       =   "input"
                        type          =   "text"
                        errorClass    =   {PageStyle.Form__Error}
                        formik        =   {formik}
                        name          =   "assessment.name"
                        style         =   {InputError(formik, "assessment.name")}
                      />
                    </div>
                    <div className={`${PageStyle.SetupPopup__ContentBlock}`}>
                      <label>{t('page:clients:tech-test-modal:texts:add_file')}</label> 
                      <div className={` WrapperRadioDpBlock customClass`}>
                        <div>
                          <label className={`Dpflex WrapperRadioContainer`}>
                            <input type="radio" name="assessment.file_type" id="option-1" value={'file'} checked={formik.values.assessment.file_type == 'file'} onChange={(event)=> techTestAction.onTestoptionChange(formik, event)} />
                            <label className={`ml5 WrapperRadioSpan`}> 
                            <span className={`ml5 WrapperRadioSpan`}>
                            <span className={`PositionRelativeRadio`}>{uploadFileText}</span>
                              <input disabled = {formik.values.assessment.file_type == 'link'} type="file" name={'assessment.file'} accept = ".pdf, .docx, .doc"  onChange={(event) => { 
                                  techTestAction.uploadFile(formik, event, setUploadFileText)
                                }} />
                            </span>
                            </label>
                            <span>{formik.values.assessment.filename }</span>
                          </label>

                          {formik.touched.assessment.file && <p className="Dpflex grid10">{formik.errors.assessment.filesize ? <><Error /><p className={`errorcolor`}>{formik.errors.assessment.filesize}</p></> : formik.errors.assessment.filename ? <><Error /><p className={`errorcolor`}>{formik.errors.assessment.filename}</p></> : ''}</p>}
                        </div>
                        <div className="Dpflex">
                          <label className={`Dpflex WrapperRadioContainer`}>
                            <input type="radio" name="assessment.file_type" id="option-2" value={'link'} checked={formik.values.assessment.file_type == 'link'} onChange={(event)=> techTestAction.onTestoptionChange(formik, event)} /> 
                            <span className="WrapperRadiocheckmark top15  ml0"></span> 
                            <span className={`ml5 WrapperRadioSpan`}> 
                            </span>
                          </label>
                          <FormikControl
                            className     =   {PageStyle.Form__Input}
                            control       =   "input"
                            placeholder   =   "Enter a link"
                            type          =   "text"
                            formik        =   {formik}
                            name          =   "assessment.link"
                            errorClass    =   {PageStyle.Form__Error}
                            style         =   {InputError(formik, "assessment.link")}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
       </div>
       <div className={PageStyle.SetupPopup__Footertechtest}>
              <div className={PageStyle.SetupPopup__SubmitSectionAutomation}>
                <Button buttonstyle={`${ButtonStyle.primarybtn} ${cursorNone(editable)}`} type="submit" disabled = {!editable}>
                {'Send'}
                </Button>
            </div>
            </div>
          </Form>
          )}
        </Formik>
      </div>

    </div>
    </div>
  </div>
  </>
  )
}

CustomTechTestModal.layout = ClientDashboard;
export default CustomTechTestModal;